import { API } from 'aws-amplify';

export const read = async () => API.get('eventmanagerUserApi', '/companies', {});

export const readOne = async (id) => API.get('eventmanagerUserApi', `/companies/${id}`, {});
